// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetOptInHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentCreditReportOptInStatusWebApiRequestDto, RentCreditReportOptInStatusWebApiResponseDto } from '../..';

export const RentCreditReportGetOptInHandler_getOptIn_Path = '/api/web/v1/rentCreditReport/getOptIn';

/**
 * Get opt in status for rent reporting
 */
export const RentCreditReportGetOptInHandler_getOptIn = (
  postData: RentCreditReportOptInStatusWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentCreditReportOptInStatusWebApiRequestDto,
    RentCreditReportOptInStatusWebApiResponseDto
  >(
    {
      endpoint: RentCreditReportGetOptInHandler_getOptIn_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
